import React, { useEffect, useState } from "react";
import "../../App.css"; // Import your global CSS for resetting and basic styling
import { getRedirectResult, signInWithPopup, signInWithRedirect } from "firebase/auth";
import { auth, provider } from "../firebase/firebase";

const style = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Poppins', sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(0px)", // Subtle background blur
  },
  formContainer: {
    background: "rgba(255, 255, 255, 0.3)", // Less transparency
    backdropFilter: "blur(10px)", // Slight blur
    padding: "15px 30px", // Reduced padding
    borderRadius: "15px", // Smaller border-radius for compactness
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Slightly smaller shadow
    textAlign: "center",
    maxWidth: "320px", // Smaller width
    width: "80%",
    border: "2px solid #f1f8e9",
  },
  h2: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: "1.6rem", // Slightly smaller font size
    padding: "8px",
    color: "#FFFFFF",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.4)",
  },
  input: {
    width: "100%",
    padding: "10px", // Reduced padding
    margin: "8px 0", // Reduced margin
    borderRadius: "8px", // Smaller border-radius
    border: "1px solid #FFFFFF",
    fontSize: "14px",
    backgroundColor: "#F1F8E9",
    boxSizing: "border-box",
    transition: "all 0.3s ease",
    outline: "none",
    color: "#333",
  },
  inputFocus: {
    borderColor: "#66bb6a",
    boxShadow: "0 0 6px rgba(102, 187, 106, 0.6)", // Subtle focus glow
  },
  button: {
    width: "100%",
    padding: "12px", // Reduced padding
    margin: "10px 0", // Slight margin reduction
    borderRadius: "8px", // Smaller border-radius
    border: "none",
    fontSize: "14px", // Slightly smaller font size
    cursor: "pointer",
    backgroundColor: "#66bb6a",
    color: "white",
    fontWeight: "bold",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.2s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  googleButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "10px", // Reduced padding
    margin: "8px 0", // Reduced margin
    borderRadius: "8px", // Smaller border-radius
    backgroundColor: "transparent",
    border: "2px solid #f1f8e9",
    color: "#f1f8e9",
    fontWeight: "bold",
    fontSize: "14px",
    textTransform: "uppercase",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  googleButtonHover: {
    backgroundColor: "#f1f8e9",
    color: "#66bb6a",
    borderColor: "#66bb6a",
  },
  googleIcon: {
    marginRight: "8px",
    transition: "transform 0.2s ease-in-out",
  },
  divider: {
    margin: "16px 0", // Reduced margin
    textAlign: "center",
    color: "#f1f8e9",
    fontSize: "12px",
    position: "relative",
  },
  dividerLine: {
    position: "absolute",
    top: "50%",
    width: "35%", // Smaller divider line
    borderTop: "2px solid #fff",
  },
  dividerLeft: {
    left: "0",
  },
  dividerRight: {
    right: "0",
  },
  errorText: {
    color: "red",
    fontSize: "12px",
    marginTop: "8px",
  },
};

const LoginPage = ({ onSignIn }) => {
  const [error, setError] = useState(null);
  const [inputFocus, setInputFocus] = useState(false);
  const [buttonHover, setButtonHover] = useState(false);
  const [inputHover, setInputHover] = useState(false);
  const [googleButtonHover, setGoogleButtonHover] = useState(false);

  // Handle Google Sign-In (with redirect for mobile)
  const handleGoogleSignIn = async () => {
    try {
      // Detect mobile vs desktop
      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        await signInWithRedirect(auth, provider);
      } else {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        onSignIn(user);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    const handleRedirectResult = async () => {
      try {
        // Wait for the redirect result
        const result = await getRedirectResult(auth);

        if (result) {
          const user = result.user;
          console.log("Google Sign-In Success: ", user);
          onSignIn(user);
        } else {
          console.log("No redirect result found");
        }
      } catch (err) {
        console.error("Error getting redirect result:", err);
        setError(err.message);
      }
    };

    handleRedirectResult();
  }, []); // Empty dependency array to run only once

  // Handle form submission (for custom login)
  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Implement your custom login logic here (Farmer ID, Mobile Number)
  };

  return (
    <div style={style.container}>
      <div style={style.formContainer}>
        <h2 style={style.h2}>Farmer Login</h2>
        <form onSubmit={handleFormSubmit}>
          <input
            style={inputHover ? { ...style.input, ...style.inputFocus } : style.input}
            type="text"
            placeholder="Farmer ID"
            onFocus={() => setInputFocus(true)}
            onBlur={() => setInputFocus(false)}
            onMouseEnter={() => setInputHover(true)}
            onMouseLeave={() => setInputHover(false)}
          />
          <input
            style={inputHover ? { ...style.input, ...style.inputFocus } : style.input}
            type="tel"
            placeholder="Mobile Number"
            onFocus={() => setInputFocus(true)}
            onBlur={() => setInputFocus(false)}
            onMouseEnter={() => setInputHover(true)}
            onMouseLeave={() => setInputHover(false)}
          />
          <button
            style={buttonHover ? { ...style.button, ...style.googleButtonHover } : style.button}
            type="submit"
            onMouseEnter={() => setButtonHover(true)}
            onMouseLeave={() => setButtonHover(false)}
          >
            Login
          </button>
        </form>
        <div style={style.divider}>
          <span style={{ ...style.dividerLine, ...style.dividerLeft }}></span>
          or
          <span style={{ ...style.dividerLine, ...style.dividerRight }}></span>
        </div>
        <button
          onClick={handleGoogleSignIn}
          style={googleButtonHover ? { ...style.googleButton, ...style.googleButtonHover } : style.googleButton}
          className="googleButton"
          onMouseEnter={() => setGoogleButtonHover(true)}
          onMouseLeave={() => setGoogleButtonHover(false)}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/archive/c/c1/20170301123009%21Google_%22G%22_logo.svg"
            alt="Matops Grow - Google Sign In"
            style={style.googleIcon}
            width="20"
          />
          Sign in with Google
        </button>
        {error && <p style={style.errorText}>{error}</p>}
      </div>
    </div>
  );
};

export default LoginPage;
